<template>
	<no-ssr>
		<component :is="component" v-model="modelValue" @input="onChange" v-bind="$attrs"><slot></slot></component>
	</no-ssr>
</template>

<script>

let Selectize = null;
if (process.client) {
	Selectize = require('vue2-selectize');
}

export default {

	props: [ 'value' ],

	data() {
		return {
			modelValue: this.value,
		};
	},

	watch: {

		value: function(newValue) {
			this.modelValue = newValue;
		},

	},

	computed: {
		component() {
			if (Selectize === null) {
				return 'select';
			}

			return Selectize;
		}
	},

	methods: {

		onChange(newValue) {
			this.modelValue = newValue;
			this.$emit('input', newValue);
		}
	}
};

</script>
